import React from "react";
import { Cpu, Database, HardDrive, Lock } from "lucide-react";
import HelpButton from "@/components/HelpButton";
import PipelineToggleCard from "@/components/PipelineToggleCard";

export default function Settings() {
  return (
    <div className="min-h-screen">
      <header className="px-8 pt-8 pb-6 border-b border-border">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-2">
              Configuration
            </div>
            <h1 className="font-display font-black uppercase text-4xl tracking-tight">Settings</h1>
          </div>
          <HelpButton topic="settings" />
        </div>
      </header>
      <div className="px-8 py-6 space-y-6">
        {/* Phase G · Live-Rollback Toggles — full-width above the
            existing read-only status cards so it's the first thing
            an operator sees when they hit the page. */}
        <PipelineToggleCard />

        <div className="grid lg:grid-cols-2 gap-6">
          <Card icon={Cpu} title="AI Pipeline">
            <Row k="Detector" v="YOLOv8x" />
            <Row k="Tracker" v="ByteTRACK" />
            <Row k="Device" v="CPU" />
            <Row k="Sample FPS" v="~5 fps" />
            <Row k="Max Clip" v="60 s" />
          </Card>
          <Card icon={HardDrive} title="Storage">
            <Row k="Provider" v="Backblaze B2 (S3)" />
            <Row k="Prefixes" v="spiele/ · sequenzen/ · datasets/" />
            <Row k="Upload Limit" v="10 GB · direct-to-B2" />
          </Card>
          <Card icon={Database} title="Database">
            <Row k="Engine" v="MongoDB" />
            <Row k="Collections" v="sequences" />
          </Card>
          <Card icon={Lock} title="Phase 1 · Roadmap">
            <Row k="Auth & Roles" v="planned (Phase 2)" />
            <Row k="Stripe / PayPal Quotas" v="planned (Phase 2)" />
            <Row k="GPU tracking" v="hot-swappable via YOLO_MODEL env" />
          </Card>
        </div>
      </div>
    </div>
  );
}

function Card({ icon: Icon, title, children }) {
  return (
    <div className="border border-border bg-card rounded-sm p-6">
      <div className="flex items-center gap-2.5 mb-4">
        <Icon className="w-4 h-4 text-primary" />
        <h2 className="font-display font-black uppercase tracking-widest text-sm">{title}</h2>
      </div>
      <div className="space-y-2 font-mono text-xs">{children}</div>
    </div>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex items-center justify-between border-b border-border/50 pb-1.5">
      <span className="text-muted-foreground uppercase tracking-widest text-[10px]">{k}</span>
      <span className="text-foreground">{v}</span>
    </div>
  );
}
